import { sdk } from 'src/utilities/sdk';
import { camelizeResponseData } from 'src/utilities/http-data-casing';
import {
  BalanceCreditInfoApiResponse,
  BalanceCreditInfoRawResponse,
} from 'src/types/Balance';

export const getBalanceCreditInfoEndpoint = (
  externalBalanceBuyerId: string
): string =>
  `/b2gexternalgateway/balance/buyers/${externalBalanceBuyerId}/credit-info`;

export async function fetchBalanceCreditInfo(
  externalBalanceBuyerId: string
): Promise<BalanceCreditInfoApiResponse> {
  const response: BalanceCreditInfoRawResponse = await sdk.http.get(
    getBalanceCreditInfoEndpoint(externalBalanceBuyerId)
  );
  return camelizeResponseData(response);
}
